import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WorkflowStepDefinition } from 'src/app/models/server/workflow-step-definition';
import { ConnectedUsersStateService } from '../state/connected-users-state.service';
import { ViewsStateService } from '../state/views-state.service';
import { ServiceBase } from './service-base';

@Injectable({
    providedIn: 'root',
})
export class WorkflowsService extends ServiceBase {
    constructor(
        private http: HttpClient,
        public override connectedUserStateService: ConnectedUsersStateService,
        private viewsStateService: ViewsStateService
    ) {
        super(connectedUserStateService);
    }

    /**
     * Liste les définitions des étapes de workflow d'une vue.
     * @param viewId Identifiant de la vue.
     * @returns La liste des définitions des étapes de workflow.
     */
    public listWorkflowStepDefinitions(viewId: number): Observable<WorkflowStepDefinition[]> {
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        };

        return this.http.get<WorkflowStepDefinition[]>(this.baseUrl + `/api/organizations/${this.userConnected.organization.id}/views/${viewId}/steps`, httpOptions);
    }
}
